<template>
  <div id="topNav">
    <div class="container-fluid">
      <div class="row">
        <div class="topnav">
          <div style="width: 1280px;margin: 0 auto">
            <div class=" brand">
              <img src="../assets/img/logo.png" alt="">
              <span style="color: white">通用仿真软件</span>
            </div>
            <div class=" links">
              <span @click="jump('index')" style="cursor: pointer">首页</span>
              <span @click="jump('productIntroduction')" style="cursor: pointer">产品介绍</span>
              <Dropdown transfer transfer-class-name="dropdwonMeun" @on-click="choseMenu">
                  <span style="cursor: pointer" @click="choseMenu(categoryList[0].children[0].id)">
                    更新说明
                  </span>
                <DropdownMenu slot="list">
                  <DropdownItem v-for="item in categoryList[0].children" :name="item.id">{{ item.name }}</DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <span @click="jump('applyCase')" style="cursor: pointer">应用案例</span>
              <Dropdown transfer transfer-class-name="dropdwonMeun" @on-click="jump">
                  <span style="cursor: pointer"  @click="jump('videoList')">
                    知识库
                  </span>
                <DropdownMenu slot="list">
                  <DropdownItem name="videoList">视频</DropdownItem>
                  <DropdownItem name="fileList">资料</DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <span @click="jump('aboutUs')" style="cursor: pointer">关于我们</span>

            </div>
            <div class=" lrblock" v-if="islogin===false">
              <div class="loginbtn" @click="jump('login')" style="cursor: pointer">登录</div>
              <div class="regbtn" @click="jump('register')" style="cursor: pointer">注册试用</div>

            </div>

            <div v-if="islogin===true" class=" lrblock">
              <!--              <span>{{userNickname}}</span>-->
              <span class="userNickname" :title="'欢迎，'+userNickname">欢迎，{{ userNickname }}</span>

              <span style="display: inline-block;overflow: hidden;width: 80px;cursor: pointer"
                    @click="logout">
                <img src="../assets/img/outlog.svg" alt="">
                退出
              </span>
              <span @click="jump('changePassWord')" title="修改密码" style="cursor: pointer;position: relative;top: -28px">
                 <img src="../assets/img/changePW.svg" alt="">
                修改密码
              </span>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <router-view></router-view>
      </div>

      <div class=" row">
        <div class="bottomNav indexPage">
          <div style="width: 1280px;text-align: left">
            <div style="margin-top: 60px" class="brand">
              <img src="../assets/img/logo.png" alt="">
              <span>通用仿真软件</span>
            </div>
            <div style="margin-top: 48px;display: flex">
              <div style="display: inline-block;width: 140px">
                <div style="color: #FFFFFF;">
                  友情链接
                </div>
                <div style="font-size: 12px;color: rgba(255,255,255,0.3);margin-top: 13px">
                  <div style="cursor: pointer" @click="openPath('https://edu.pkpm.cn/')">CAE共享知识平台</div>
                  <div style="cursor: pointer" @click="openPath('https://product.pkpm.cn/searchPage?categoryId=all&searchKey=allCondition')">PKPM BIMBase 产品中心</div>
                  <div style="cursor: pointer" @click="openPath('https://pkpm.cn/')">北京构力科技有限公司</div>
                </div>
              </div>
              <div style="display: inline-block;width: 255px;margin-left: 120px">
                <div style="color: #FFFFFF;">
                  联系我们
                </div>
                <div style="font-size: 12px;color: rgba(255,255,255,0.3);margin-top: 13px;">
                  <div>电子邮箱：cae@cabrtech.com</div>
                  <div>联系电话：400-8000-900</div>
                  <div>地址：北京市朝阳区和平街街道北三环东路30号</div>
                </div>
              </div>
              <div style="display: inline-block;margin-left: 434px">
                <div style="color: #FFFFFF;">
                  构力科技
                </div>
                <div style="margin-top: 20px">
                  <img src="../../static/img/bottomNav/gouliTec.png" alt="">
                </div>
              </div>
              <div style="display: inline-block;margin-left: 80px">
                <div style="color: #FFFFFF;">
                  构力学堂
                </div>
                <div style="margin-top: 20px">
                  <img src="../../static/img/bottomNav/gouliStudy.png" alt="">
                </div>
              </div>
            </div>
            <div style="width: 100%;height: 1px;background-color: rgba(255,255,255,0.16);margin-top: 60px"></div>
            <div style="font-size: 12px;color: rgba(255,255,255,0.3);margin-top: 23px;text-align: center">
              Copyright © 2020.Beijing Glory PKPM Technology Co.,Ltd. All rights reserved. ICP备案:京ICP备17027954号-1
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {logout, userState, listCategory} from '../api/index'

export default {
  name: "topNav",

  data() {
    return {
      value1: 0,
      userNickname: '',
      userId: '',
      // auth: [],
      islogin: false,

      categoryList: [{children:[]}],
      nowPath: 'index'
    }
  },
  computed: {
    pageData() {
      return this.$store.state.nowPage;
    }
  },
  watch: {
    pageData(newVal) {
      // console.log('Store 数据变化：', newVal);
      if (newVal === 0) {
        document.getElementsByClassName('topnav')[0].style.background = 'rgba(0,0,0,0.2)'
      } else {
        document.getElementsByClassName('topnav')[0].style.background = '#0069E0'
      }
    },
    '$route'(to, from) {
        console.log(to.path)
        this.nowPath = to.path
        let spans = document.getElementsByClassName('links')[0].querySelectorAll('span');
        spans.forEach((item) => {
          item.classList.remove("active")
        })
        this.getNowRouter(spans)

        console.log('新路径：', to.path)
      }

  },
  methods: {
    getNowRouter(spans){
      switch (this.nowPath) {
        case '/index':
          spans[0].classList.add("active")
          break;
        case '/productIntroduction':
          spans[1].classList.add("active")
          break;
        case '/updateNote':
          spans[2].classList.add("active")
          break;
        case '/applyCase':
          spans[3].classList.add("active")
          break;
        case '/videoList':
        case '/fileList':
          spans[4].classList.add("active")
          break;
        case '/aboutUs':
          spans[5].classList.add("active")
          break;
        default:
          spans[0].classList.add("active")
          break;
      }
    },
    choseMenu(item) {
      this.$router.push({
        path: '/updateNote',
        query: {
          id: item
        }
      })
      this.$router.replace({
        path: '/redirect' + this.$route.fullPath
      })
    },
    jump(target) {
      if (target == "downloadCenter") {
        window.open(this.$router.resolve({path: 'downloadCenter',}).href, '_blank')
      } else {
        this.$router.push(target)
      }
    },

    logout() {
      logout().then((res) => {
        console.log(res)
        let resData = res.data
        if (resData.result.success == true) {
          this.$cookies.remove("userId");
          this.$cookies.remove("nickName");
          this.$cookies.remove("userName");
          this.$cookies.remove("auth");
          this.$cookies.remove("isLogin");
          this.islogin = false
          this.$Message.success("退出登录成功");
        } else {
          this.$Message.error(resData.result.info);
        }
      }).catch((error) => {
        console.log(error)
      })
    },


    getUserState() {

      this.$cookies.set("isLogin", this.islogin, '30d')
      userState().then((res) => {
        if (res.data.code == 0) {
          let resdata = res.data;
          if (resdata.result.success == true) {
            this.islogin = true;
            this.userId = resdata.result.data.user.id;
            this.userNickname = resdata.result.data.user.nickname;
            this.$cookies.set("userId", this.userId, '30d')
            this.$cookies.set("userName", this.userNickname, '30d')
            this.$cookies.set("nickName", resdata.result.data.user.nickname, '30d')
            this.$cookies.set("auth", resdata.result.data.auth, '30d')
            this.$cookies.set("isLogin", this.islogin, '30d')
          } else {
            this.islogin = false;
            this.$cookies.set("isLogin", this.islogin, '30d')
            // this.$Message.error(resdata.result.info);
          }
        } else {
          this.islogin = false;
          this.$cookies.set("isLogin", this.islogin, '30d')
          // this.$Message.error(res.data.msg);
        }
      }).catch((error) => {
        console.log(error);
        this.$Message.error(error.data.msg);
      });
    },

    getCategoryList() {
      let data = {
        type: 'intro',
        sortName:'name',
        sortType:'desc'
      }
      listCategory(data).then((res) => {
        if (!res.data.result.success) {
          this.$Message.error(res.data.result.info);
        } else {
          this.categoryList = res.data.result.categorys
          this.categoryList.forEach((item) => {
            item.showChildren = false
          })
          // // //临时处理
          // const lastElement = this.categoryList[0].children.pop();
          // this.categoryList[0].children.unshift(lastElement);

          console.log(this.categoryList[0].children)
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    openPath(path){
      window.open(path)
    }

  },

  mounted() {
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      if (currentScroll >= 300) {
        this.$store.commit('changePage', 1);
      }else{
        this.$store.commit('changePage', 0);
      }
    });
    this.getUserState();
    this.getCategoryList()
    this.nowPath=this.$route.path
    let spans = document.getElementsByClassName('links')[0].querySelectorAll('span');
    spans.forEach((item) => {
      item.classList.remove("active")
    })
    this.getNowRouter(spans)
  },

}
</script>

<style scoped lang="scss">
.topnav {
  width: 100%;
  position: fixed;
  z-index: 999;
  top: 0;
  height: 66px;
  /*background: #02298B;*/
  background: rgba(0, 0, 0, 0.2);

  .brand {
    display: inline-block;

    img {
      width: 150px;
    }

    span {
      display: inline-block;
      color: white;
      font-size: 22px;
      vertical-align: bottom;
    }
  }

  .links {
    display: inline-block;
    height: 65px;
    line-height: 65px;
    text-align: right;
    margin-left: 85px;

    span {
      text-align: center;
      display: inline-block;
      height: 65px;
      padding: 0 20px;
      font-size: 16px;
      color: white;
    }

    span:hover {
      color: white;
      border-bottom: 3px solid #ffffff;
    }

  }

  .lrblock {
    float: right;
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    height: 65px;
    line-height: 65px;
    color: white;

    .loginbtn {
      display: inline-block;
      padding: 0 17px;
      color: white;
    }

    .regbtn {
      display: inline-block;
      padding: 0 17px;
      color: white;
    }
  }

  .userNickname {
    width: 140px;
    display: inline-block;
    margin-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}


.bottomNav {
  display: flex;
  justify-content: center;
  bottom: 0;
  text-align: center;
  width: 100%;
  height: 424px;
  background: url("../../static/img/bottomNav/bottomBack.png");

  .brand {
    display: inline-block;

    img {
      margin-top: 18px;
      width: 52%;
    }

    span {
      display: inline-block;
      color: white;
      position: relative;
      font-size: 22px;
      top: 15px;
      left: 15px;
    }
  }
}

.dropdwonMeun {
  background: blue;
}

.active {
  color: white;
  border-bottom: 3px solid #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/topNav.vue